var en = {
    news: {
        sort: 'sort',
        publishTime: 'Publish Time',
        sales: 'Sales',
        values: 'Recommended values',
        create: 'Create a crosstalk relationship',
        msg1: 'Automatically create corresponding distributors and suppliers',
        msg2: 'Direct use of global warehouse payment, one single clearing',
        msg3: 'Manually assign distributors and suppliers respectively',
        msg4: 'Negotiate payment method with the other party'
    },
    "common":{
        "all":"All",
        "ticket":"Ticket",
        "package":"Package",
        "route":"Tour Route",
        "hotel":"Hotel",
        "buy":"Flash Sale",
        "performance":"Shows&Activities",
        "carRental":"Rental Cars",
        "visa":"Visa",
        "airTickets":"Flights",
        "commodities":"Commodities",
        "flashSale":"Flash sale",
        "carRentalNew":"Car rental(new)",
        "traffic":"Traffic",
        "pleaseInput":"Please enter {name}",
        "search":"Search",
        "allLanguage":"All language",
        "chinese":"简体中文",
        "japanese":"Japanese",
        "english":"English",
        "setting":"Setting",
        "classification":"classification",
        "changeLanguage":"Change language",
        "aboutUs":"About us",
        "contactUs":"Contact us",
        "finalPrice":"Final",
        "retailPrice":"Retail",
        "bind":"Binding",
        "oneBind": "One key binding",
        "handBind": "Manual binding",
        "unbind":"Dereference",
        "quote":"Reference",
        //弹窗
        "close":"close",
        "quoteProduct":"Reference Product",
        "quoteCentence":"Are you sure to reference the product?",
        "confirm":"Confirm",
        "cancel":"Cancel",
        "unbindProduct":"Dereference Product",
        "unbindCentence":"Are you sure you want to dereference the product?",
        "noData":"No Data",
        "validity":"validity",
        "review":"Under review",
        "noMore":"No more data",
        "queryFailed":"Query failed",
        "startDate": "start date",
        "endDate": "end date"
    },


    "home": {
        "myCenter":"Center",
        "continent":"Continent/Country",
        "country":"Country/Province",
        "province":"Province/City",
        "cities":"City/Area",
        "destination":"Destination",
        "quickSearch":"Quick search",
        "periphery":"Around",
        "inland":"Mainland",
        "overseas":"Overseas",
        "HMT":"HK/MO/TW",
        "hotRecommend":"Hot",
        "hotRanking":"Rank",
        "newRanking":"New",
        "centent":"Search all global travel products as you want!",
        "list":"Hotel、Tickets、Packages、Tour Route...",
        "openWarehouse":"Confirm open the warehouse",
        "yes":"Yes",
        "no":"No",
        "agree":"I have read and agree to the ",
        "terms":"terms",
        "operatorNav":"Operator Navigation",
        "keyContent":"product name / scenic name / product number keywrods"
    },

    "account": {
        "home":"Home",
        "accountSetting":"Account setting",
        "myPage":"My homepage",
        "myProducts":"My products",
        "relatedBusinessess":"Related Operators",
        "systemGrade":"SystemGrade",
        "systemRecommended":"Recommendation",
        "serviceLevel":"Service",
        "serviceSpeed":"Processing speed",
        "realInventory":"Inventory",
        "hotSelling":"Hot selling products",
        "CNY":"China Yuan(CNY)",
        "JPY":"Japanese Yen(JPY)",
        "KRW":"Korean Won(KRW)",
        "USD":"U.S Dollar",
        "accountBalance":"Account Balance",
        "salesAchievement":"Sales Achievement",
        "number":"Sales Volume",
        "orderTotal":"Sales Amount",
        "selling":"Sell (",
        "buying":"Buy (",
        "bracket":")",
        "merchantName":"Operator",
        "correlationTime":"Binding Time",
        "sellingNumber":"Sales Volume",
        "buyingNumber":"Buying number",
        "unbind":"Unbind",
        "recharge":"Recharge",
        "withdrawal":"Withdrawal",
        "transactionDetail":"Detail",
        "unbindTip":"This operation will cause the product reference data to clear, whether to confirm the lifting of the relationship?",
        "tip":"Tip",
        "unbindSuccess":"Relationship lifted successfully!",
        "unbindFail":"Relationship lifted failed!",
        "successModify":"Successfully modified",
        "failedModify":"Modification failed",
        "viewDis":"Distributed",
        "viewSup":"Supplied"
    },

    "cash": {
        "unit":"Yuan",
        "Withdrawal":"Cash withdraw amount",
        "withdrawal":"Cash withdrawal(",
        "bracket":")",
        "myCenter":"Center",
        "withdrawalRecord":"Cash withdrawal record",
        "accountBalance":"Account balance",
        "withdrawalAmount":"Cash withdrawal amount",
        "line":"(Unvisited orders can only be made up to 0%)",
        "choose":"Cash withdrawal way",
        "amount":"Cash withdrawal amount",
        "enter":"Enter amount",
        "contrl":"Cash withdrawal",
        "explanation":"Explanation",
        "line1":"Current system support to pay for alipay or bank account;",
        "line2":"Once the system binding account can not be replaced independently, if you need to modify the binding account, please contact the operator to apply;",
        "line3":"Cash withdrawal procedures:3%/per",
        "line6":"After the user submits the cash withdrawal application, the operator will process it within one working day;",
        "line7":"Once the application is made, the system will call the current alipay account or the bank account to generate the withdrawal record, and once withdrawal records generated, can not do any operation;",
        "line8":"Users using the global warehouse supplier function need to retain the balance of the account with the amount of 3,000 yuan as a credit guarantee, the user can withdraw part of more than 3,000 yuan (or more than the equivalent of 3,000 yuan in foreign currency)",
        "line9":"The user may withdraw all the credit margin only after all the orders as suppliers have been completed for 30 days;",
        "amountTip":"Please enter the withdrawal amount",
        "validAmount":"Please enter the amount of cash available!",
        "selectAccount":"Please select an account",
        "servicePay":"3%/per",
        "notAllow":"Not allowed to withdraw",
        "reserveTip":"To be a global warehouse supplier, the amount of RMB3000 shall be retained in the account balance as the credit deposit, and the withdrawal can only be made after 30 days after all the orders as suppliers have been completed",
        "userName":"User's name",
        "accountNum":"Account",
        "tail":"Tail"
    },

    "operator": {
        "telephone":"Telephone",
        "address":"Address",
        "systemGrade":"SystemGrade",
        "systemRecommended":"Recommendation",
        "serviceLevel":"Service",
        "serviceSpeed":"Processing speed",
        "realInventory":"Inventory",
        "hotSelling":"Hot selling products",
        webSite : '网址'
    },

    "recharge": {
        "unit":"Yuan",
        "Recharge":"Recharge",
        "recharge":"Recharge(",
        "bracket":")",
        "myCenter":"Center",
        "rechargeRecord":"Recharge record",
        "RtoB":"Recharge to balance",
        "enter":"Enter the amount",
        "payee":"Payee",
        "depositCard":"Online banking",
        "escrow":"Escrow",
        "underLine":"Under Line",
        "saasBalance":"Saas Balance",
        "cardWarn":"*Bank gateway payment, no credit card",
        "escrowWarn":"*YEEPAY channel support credit card",
        "amountTip":"Please enter the recharge amount",
        "accountTip":"Please choose payment account",
        "rechargeDes":"Explanation",
        "line3":"Recharge fee：",
        "line4":"The dealer will pay 1‰ of transaction amount for service fee to recharge via Alipay or online banking (less than 0.01 yuan per 0.01 yuan);",
        "amountNum":"Recharge amount at least ¥ 1 yuan",
        "underLinStep1Label": "Step 1",
        "underLinStep1Val": "首先通过转账等方式将充值的金额存入到自我游账户下",
        "underLinStep2Label": "Step 2",
        "underLinStep2Val": "保存好银行资金处理信息（流水号、金额、银行等）",
        "underLinStep3Label": "Step 3",
        "underLinStep3Val": "找到自我游客服QQ，讲信息发给客服处理",
        "underLinStep4Label": "Step 4",
        "underLinStep4Val": "等待自我游审核资料",
        "underLinStep5Label": "Step 5",
        "underLinStep5Val": "全球货仓账户充值完毕"
    },

    "search": {
        "pleaseEnter":"Please enter {name}",
        "myCenter":"Center",
        "home":"Home",
        "continent":"Continent/Country",
        "country":"Country/Province",
        "province":"Province/City",
        "cities":"City/Area",
        "keywords":"keywords",
        "keyContent":"product name / scenic name / product number keywrods"
    },

    "popup":{
        "about":{
            "aboutUs":"About us",
            "companyProfile":"Company profile",
            "profile1":"Global tourism Product Warehouse (gtpw.zowoyoo.com) is a leading technology-based B2B tourism platform. Global Travel Warehousing is committed to becoming the global trading center of Fragmented products, through its own technology to effectively match the supply and demand, one-click to complete the supplier selection, to complete best product matching, and payment issues. It is designed to help users easily access to global tourism product resources."
        },

        "contact":{
            "contactUs":"Contact us",
            "name":"Guangzhou Zhiwoyou Tour Agency Limited Headquarters(GTPW)",
            "address":"Address: No. 309 Huangpu Road, Yangcheng Creative Industry Zone 3-08A,1st Floor, Tianhe District, Guangzhou",
            "email":"Email",
            "website":"Website",
            "account":"Experience account",
            "password":"Experience password",
            "supply":"Supplier cooperation",
            "distribution":"Distribution cooperation",
            "market":"Marketing cooperation",
            "telephone":"Customer service telephone",
            "qq":"Customer service QQ"
        },

        "account":{
            "account":"Account setting",
            "introduction":"Merchant introduction",
            "contact":"Contact information",
            "telephone":"Tel",
            "qq":"QQ",
            "address":"Ad",
            "save":"Save"
        },

        "transaction":{
            "detail":"Transaction Detail",
            "dealDate":"Trading date",
            "today":"Today",
            "yesterday":"Yesterday",
            "7days":"Last 7 days",
            "30days":"Last 30 days",
            "chooseDate":"Choose date",
            "paymentsType":"Payments type",
            "all":"All",
            "income":"Income",
            "expense":"Expense",
            "tradingContent":"Trading content",
            "tradingMerchant":"Trading Operator",
            "recharge":"Recharge",
            "withdrawal":"Withdrawal",
            "pay":"Pay",
            "refund":"Refund",
            "number":"Order number/notification number",
            "date":"Date",
            "operator":"Operator",
            "expenseAmount":"Expense",
            "incomeAmount":"Income",
            "currencyBalance":"Current Balance",
            "remark":"Note",
            "endTip":"Please enter the end time",
            "startTip":"Please enter the start time",
            "orderValid":"Please enter a valid single number",
            "orderId":"Order",
            "export":"Export ",
            "exportTip": "Export up to 20000 records at a time, you can narrow the time range you want to query multiple export",
            "noData":"No relevant data"
        },

        "relation":{
            "title":"Establish Relationship",
            "systemSupplier":"System supplier",
            "province":"Continent/Country",
            "city":"Country/Province",
            "supplier":"Supplier",
            "keyword":"Enter supplier keyword",
            "position":"Rapidly position the supplier",
            "notFound":"Not found the supplier?",
            "create":"Create the supplier",
            "distributor":"Products corresponding to the distributor",
            "account":"Distributor account",
            "password":"Distributor password",
            "enterAccount":"Enter distributor account",
            "enterPassword":"Enter distributor password",
            "createAndEstablish":"Create the distributor",
            "establish":"Establish relationship",
            "keywordTip":"Please enter keywrods!",
            "supTip":"Please select supplier",
            "disTip":"Distributor information can not be empty",
            "audit":"开通串货成功，商户正在审核",
            "pass":"开通串货成功"
        },

        "recharge":{
            "title":"Recharge Record",
            "dealDate":"Trading date",
            "7days":"Last 7 days",
            "30days":"Last 30 days",
            "recordNumber":"No.",
            "date":"Date",
            "operator":"Operator",
            "originalBalance":"Original Balance",
            "rechargeAmount":"Amount",
            "accountBalance":"Current Balance",
            "transaction":"Serial No.",
            "rechargeAccount":"Account",
            "rechargeWay":"Recharge Method",
            "explanation":"Explanation",
            "endTip":"Please enter the end time",
            "startTip":"Please enter the start time"
        },

        "record":{
            "title":"Withdrawal Record",
            "dealDate":"Trading date",
            "7days":"Last 7 days",
            "30days":"Last 30 days",
            "withdrawalNumber":"No.",
            "date":"Date",
            "operator":"Operator",
            "originalBalance":"Original Balance",
            "withdrawalAmount":"Amount",
            "accountBalance":"Current Balance",
            "transaction":"Serial No.",
            "withdrawalAccount":"Account",
            "withdrawalWay":"Withdrawal Method",
            "explanation":"Explanation",
        },
        "productDetail":{
            "productIntro":"Product Introduction",
            "noLimit":"Unlimited number",
            "autoConfirm":"Manual  confirmation",
            "sendMsg":"Send messages",
            "supportThat":"Allow booking on the day",
            "validity":"validity",
            "ahead":"",
            "day":"day in advance| days in advance",
            "max":"Up to",
            "num":""
        },
        "qr":{
            "paymentCode":"Payment Code",
            "use": "Please use Alipay to scan the QR code below to pay to",
            "zwy": " zowoyoo",
            "nullString":""
        }
    }

}
export { en }


// WEBPACK FOOTER //
// ./src/i18n/en.js